export const openPrioritiesDrawer = () => {
    return {
        type: 'PRIORITIES_DRAWER',
        payload: true
    }
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/ActionsDrawer/components/CandidateItem/components/Priority/actions.js